import React from 'react';
import config from 'config';
import newlogo from 'images/logo.png';
// import Grid from '@material-ui/core/Grid';
// import AppBar from '@material-ui/core/AppBar';
// import Toolbar from '@material-ui/core/Toolbar';
// import Button from '@material-ui/core/Button';
// import { Typography } from '@material-ui/core';

// import logo from 'images/logo.svg';



const Header = () =>{
    return (
        <a href={config.portalUrl || '#'} className="App-logo-link">
            <img src={newlogo} className="App-new-logo" alt="Hon" />
        </a>
    )
}

// const Header = props => {
//     const { classes, isAuthenticated, userDisplayName } = props;

//     return (
//         <AppBar color="default" className={classes.appBar}>
//           <Toolbar>
//                 <Grid container justify="space-between" alignItems="center" spacing={16}>
//                     <Grid container item alignItems="center" xs={6} spacing={16}>
//                         <Grid item>
//                             <a href= { config.portalUrl } className="App-logo-link">
//                                 <img src={logo} className="App-logo" alt="Hon"/>
//                             </a>
//                         </Grid>
//                         <Grid item>
//                         {
//                             userDisplayName ?
//                             <Typography className={ classes.headerWelcome }>
//                                 Welcome,  {userDisplayName}
//                             </Typography> : ""
//                         }
//                         </Grid>
//                     </Grid>
//                     <Grid container item justify="flex-end" xs={6} spacing={16}>
//                         <Grid item>
//                             <Button
//                                 className={ classes.headerBtn }
//                                 variant="contained"
//                                 color="primary"
//                                 href={ config.portalUrl }
//                             >
//                                 Portal Home
//                             </Button>
//                         </Grid>
//                         <Grid item>
//                             <Button
//                                 className={ classes.headerBtn }
//                                 variant="contained"
//                                 color="secondary"
//                                 href={ isAuthenticated === true ? '/logout' : '/login' }
//                             >
//                                 { isAuthenticated === true ? 'Log out' : 'Login' }
//                             </Button>
//                             <br /><br />
//                             <a
//                                 className={ classes.faqLink }
//                                 href={ config.faqUrl }
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                             >
//                                 Need more help?
//                             </a>
//                         </Grid>
//                     </Grid>
//                 </Grid>
//           </Toolbar>
//         </AppBar>
//     );
// }



export default Header;